import { Skeleton } from "@mui/material";
import { useHunterPrerequisitesByUserIDQuery } from "Api/Queries/Hunter/useHunterPrerequisitesQuery";
import { HunterPrerequisitesForm } from "Components/Hunter/HunterPrerequisitesForm/HunterPrerequisitesForm";
import { HunterPrerequisitesReadOnly } from "Components/Hunter/HunterPrerequisitesForm/HunterPrerequisitesReadOnly";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.HunterPrerequisites;

type Props = {
  userID: number;
  isReadOnly?: boolean;
};

export const HunterPrerequisitesFormInitializer = ({
  userID,
  isReadOnly,
}: Props) => {
  const { t } = useResource();
  const { data: prerequisites, isLoading } =
    useHunterPrerequisitesByUserIDQuery(userID);

  if (isLoading) {
    return <Skeleton variant="rounded" height={200} />;
  }

  if (!prerequisites) {
    return <ErrorText>{t(RESOURCES.LoadingError)}</ErrorText>;
  }

  if (isReadOnly) {
    return (
      <HunterPrerequisitesReadOnly
        prerequisites={prerequisites.items}
        completedCount={prerequisites.completedCount}
        totalCount={prerequisites.totalCount}
      />
    );
  }

  return (
    <HunterPrerequisitesForm
      userID={userID}
      prerequisites={prerequisites.items}
      completedCount={prerequisites.completedCount}
      totalCount={prerequisites.totalCount}
    />
  );
};
